import React, { ReactElement } from 'react';
import striptags from 'striptags';
import { Breed } from '../../../structures/models/breed';
import { BREED_DEFAULT_IMAGE } from '../../../utils/constants';
import { cloudinaryTransform } from '../../../utils/cloudinaryTransformations';
import { setFallbackImage } from '../../../utils/imageHelper';

export interface SimilarBreedCardInterface extends Pick<Breed,
  'id' | 'name' | 'thumbnailUrl' | 'route' | 'subtitle'
> {}

interface SimilarBreedCardProps {
  breed: SimilarBreedCardInterface;
  listingType: string;
}

const SimilarBreedCard: React.FC<SimilarBreedCardProps> = ({
  breed,
  listingType,
}): ReactElement => {
  return (
    <>
      <a
        className="similar-breed-card"
        href={`${breed.route}/${listingType}`}
      >
        <div className="card custom-card p-4">
          <img
            onError={(e) => {
              setFallbackImage(e, BREED_DEFAULT_IMAGE);
            }}
            src={breed.thumbnailUrl ? cloudinaryTransform(
              breed.thumbnailUrl,
              [
                'c_thumb',
                'w_80',
                'h_80',
              ],
            ) : BREED_DEFAULT_IMAGE}
            className="card-img-top"
            alt=""
          />
          <div className="card-body">
            <h5 className="card-title m-0">{breed.name}</h5>
            <div className="puppy-description my-0">{striptags(breed.subtitle)}</div>
          </div>
        </div>
      </a>
    </>
  );
};

export default SimilarBreedCard;
